// 商品名を1行に固定し、はみ出す時だけ横に流す（商品ページと商品カードで共通）。main-product.liquid の定義と同じ中身
if (!customElements.get('title-marquee')) {
                    customElements.define('title-marquee', class extends HTMLElement {
                      connectedCallback() {
                        this.track = this.querySelector('.title-marquee__track');
                        this.text = this.querySelector('.title-marquee__text');
                        this.addEventListener('click', () => {
                          if (!this.anim) return;
                          this.anim.playState === 'paused' ? this.anim.play() : this.anim.pause();
                        });
                        this.ro = new ResizeObserver(() => this.setup());
                        this.ro.observe(this);
                        if (document.fonts) document.fonts.ready.then(() => this.setup());
                      }
                      disconnectedCallback() { this.ro && this.ro.disconnect(); this.stop(); }
                      stop() {
                        if (this.anim) { this.anim.cancel(); this.anim = null; }
                        const clone = this.track.querySelector('[data-clone]');
                        if (clone) clone.remove();
                        this.classList.remove('is-overflowing');
                      }
                      setup() {
                        const width = this.text.getBoundingClientRect().width;
                        const box = this.clientWidth;
                        if (this.lastKey === width + ':' + box) return;
                        this.lastKey = width + ':' + box;
                        this.stop();
                        if (width <= box + 1) return;
                        this.classList.add('is-overflowing');
                        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
                        const clone = this.text.cloneNode(true);
                        clone.setAttribute('data-clone', '');
                        clone.setAttribute('aria-hidden', 'true');
                        this.track.appendChild(clone);
                        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
                        const distance = width + gap;
                        const hold = 2500, move = distance / 40 * 1000;
                        this.anim = this.track.animate([
                          { transform: 'translateX(0)', offset: 0 },
                          { transform: 'translateX(0)', offset: hold / (hold + move) },
                          { transform: 'translateX(' + (-distance) + 'px)', offset: 1 }
                        ], { duration: hold + move, iterations: Infinity, easing: 'linear' });
                      }
                    });
                  }

/* レビュー0件の商品：「0.0」と空の棒グラフを隠し、「レビューを書く」だけ残す（Air Reviewsは後から描画されるので監視して判定） */
(function () {
  function check() {
    document.querySelectorAll('.AirReviews-Blocks__SummaryWrapper').forEach(function (w) {
      var c = w.querySelector('.AirReviews-Blocks--ReviewCount__Text');
      if (!c) return;
      var n = parseInt(c.textContent.replace(/[^\d]/g, ''), 10);
      var empty = n === 0;
      w.classList.toggle('nz-rv-empty', empty);
    });
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; check(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', check);
})();

/* フッターが見えたら、追従カートとLINEクーポンのボタンを引っ込める（フッターの上に重ならないように） */
(function () {
  function init() {
    var foot = document.querySelector('.nz-foot') || document.querySelector('footer.footer');
    if (!foot || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle('nz-at-footer', entries[0].isIntersecting);
    }).observe(foot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* レビュー投稿フォームのクーポン案内：アプリ内蔵の英語文言（管理画面から変えられない部分）を日本語に置き換える */
(function () {
  function ja(el) {
    var t = el.textContent.replace(/\s+/g, ' ').trim();
    if (!/[A-Za-z]{3,}/.test(t) || !/discount|characters?|photos?/i.test(t)) return;
    var m, h = null;
    if ((m = t.match(/Write (\d+) more characters? and upload (\d+) more photos?.*? for (\S+) OFF/i))) {
      h = 'あと<b>' + m[1] + '</b>文字と写真<b>' + m[2] + '</b>枚を足して投稿すると、<span class="AirReviews-Discount__ContentDiscount">' + m[3] + 'OFF</span>クーポンをプレゼント';
    } else if ((m = t.match(/Write (\d+) more characters?.*? for (\S+) OFF/i))) {
      h = 'あと<b>' + m[1] + '</b>文字書いて投稿すると、<span class="AirReviews-Discount__ContentDiscount">' + m[2] + 'OFF</span>クーポンをプレゼント';
    } else if ((m = t.match(/Upload (\d+) more photos?.*? for (\S+) OFF/i))) {
      h = 'あと写真<b>' + m[1] + '</b>枚を添えて投稿すると、<span class="AirReviews-Discount__ContentDiscount">' + m[2] + 'OFF</span>クーポンをプレゼント';
    }
    if (h) el.innerHTML = h;
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('.AirReviews-Discount__Content').forEach(ja);
    });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
